// export const baseURL = "http://127.0.0.1:8000/api/v1/";
// export const baseLogin = "http://127.0.0.1:8000/";

export const baseURL = "https://rtr.profedu.uz/api/v1/";
export const baseLogin = "https://rtr.profedu.uz/";